import { cx } from "react-emotion";
import React from "react";
import shortid from "shortid";
import SvgIcon from "components/SvgIcon";
import radio from "./radio.svg";
import _ from "lodash";

function KaInputRadio(props) {
  const {
    id = shortid.generate(),
    label,
    name,
    style = {},
    labelWidth = "",
    inputWidth = "",
    form,
    value,
    icon,
    onChange,
    disabled,
    iconVisibleMobile = false,
    iconVisible = true,
    labelColoring = true,
    iconFirst = true,
    data,
  } = props;

  // const { value, onChange, format = "YYYYMMDD", formatCast = String } = props;

  const checked = value === _.get(form?.data || data, name);

  const iconEl = iconVisible ? (
    <label className={cx("control-label", icon, iconVisibleMobile ? "" : "hidden-xs", inputWidth)} htmlFor={id}>
      <SvgIcon src={radio} className={"icon"} />
    </label>
  ) : null;

  return (
    <div
      style={style}
      className={["radio", iconFirst && "iconFirst", checked && "selected"].filter(Boolean).join(" ")}
      data={form?.data || data}
    >
      {iconFirst && iconEl}
      <label htmlFor={id} className={["control-label", labelWidth, labelColoring ? "labelColoring" : ""].join(" ")}>
        {label || name}
      </label>
      <div className={inputWidth}>
        {!iconFirst && iconEl}
        <input
          id={id}
          className="control-label hidden"
          name={name}
          onChange={!disabled && onChange}
          value={value}
          type="radio"
          checked={checked}
        />
      </div>
    </div>
  );
}

export default KaInputRadio;
